import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { List } from 'immutable';
import ConnectionKeys from 'automation-ui-action-features/constants/ConnectionKeys';
import ListBranch from 'automation-ui-action-features/records/ListBranch';
import BranchConnectionMixin, { BranchConnectionMixinDefaultValues, branchConnectionFromJSON } from 'automation-ui-action-features/records/connection/BranchConnectionMixin';
const ListBranchConnectionDefaultValues = Object.assign({}, BranchConnectionMixinDefaultValues, {
  [ConnectionKeys.LIST_BRANCHES]: [],
  [ConnectionKeys.CLASSIC_LIST_ID]: null
});
export default class ListBranchConnection extends BranchConnectionMixin(createImmutableObjectClass(ListBranchConnectionDefaultValues, {
  fromJSON: _ref => {
    let _ConnectionKeys$LIST_ = ConnectionKeys.LIST_BRANCHES,
      {
        [_ConnectionKeys$LIST_]: listBranches
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, [_ConnectionKeys$LIST_].map(_toPropertyKey));
    return Object.assign({}, rest, branchConnectionFromJSON(rest), {
      [ConnectionKeys.LIST_BRANCHES]: List((listBranches || []).map(branchJSON => new ListBranch(branchJSON)))
    });
  },
  toJSON: _ref2 => {
    let _ConnectionKeys$LIST_2 = ConnectionKeys.LIST_BRANCHES,
      {
        [_ConnectionKeys$LIST_2]: listBranches
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, [_ConnectionKeys$LIST_2].map(_toPropertyKey));
    return Object.assign({}, rest, {
      [ConnectionKeys.LIST_BRANCHES]: listBranches.toArray().map(branch => branch.toJSON())
    });
  }
})) {
  getBranches() {
    return this[ConnectionKeys.LIST_BRANCHES];
  }
  setBranches(listBranches) {
    return this.set(ConnectionKeys.LIST_BRANCHES, listBranches);
  }
}